import React from "react";
import "./Intro.css";
import Vector1 from "../../img/Vector1.png";
import Vector2 from "../../img/Vector2.png";
import bg from "../../img/bg.png";
import thumbup from "../../img/thumbup.png";
import crown from "../../img/crown.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

const Intro = () => {
  // Transition
  const transition = { duration: 2, type: "spring" };

  const formatText = (text) => {
    return text
      .split(" ")
      .map(
        (word, index) =>
          `<span class="orange-first-letter">${word[0]}</span>${word.slice(1)}`
      )
      .join(" ");
  };

  return (
    <div className="Intro" id="Intro">
      <div className="i-left">
        <div className="i-name">
          <span
            className="tacm"
            dangerouslySetInnerHTML={{
              __html: formatText("Laboratoire Esisa Analytica"),
            }}
          />
          <span className="tacm checktab">
            Là où le développement logiciel se fusionne avec l'innovation IA
          </span>
          <span className="span3 checktab tacm" style={{ margin: "2rem" }}>
            Laboratoire de recherche spécialisé en Intelligence Artificielle,
            axé sur les solutions avancées en Machine Learning, Deep Learning
            et Data Science.
          </span>
        </div>
        <Link className="tacm" to="contact" smooth={true} spy={true}>
          <button className="button i-button formatmobilebtn">Nous contacter</button>
        </Link>
        <div className="experience" id="experience">
          <div className="achievement">
            <div className="circle">25+</div>
            <span>Années </span>
            <span>d'expérience</span>
          </div>
          <div className="achievement">
            <div className="circle">20+</div>
            <span className="tac">Projets innovants </span>
            <span>développés</span>
          </div>
          <div className="achievement">
            <div className="circle">5+</div>
            <span className="tac">Entreprises </span>
            <span>accompagnées</span>
          </div>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img className="logoesisa" src={bg} alt="" />
        <motion.div
          initial={{ top: "-4%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={crown} text1="Développement " text2="logiciel" />
        </motion.div>
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={thumbup} text1="Machine/Deep Learning" text2="Software" />
        </motion.div>
        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            background: "#C1F5FF",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-9rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;